export default function background () {
    const el = $('[data-bg-image]');
    let bgImg;

    if (typeof (el) !== 'undefined' && el !== null){

        el.each(function () {
            bgImg = $(this).attr('data-bg-image');

            $(this).css({
                'background-image': 'url(' + bgImg + ')'
            });
        });
    }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/background.js